// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { getIndividualAssignmentDocument } from "../../../redux/actions/assignmentDocumentActions";
// import FileView from "../../Courses/FileViews";

// const DocumentViewer = ({ match }) => {
//   const { assignmentDocumentId } = match.params;
//   console.log(assignmentDocumentId);
//   const { assignmentDocument } = useSelector((state) => state);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(getIndividualAssignmentDocument(assignmentDocumentId));
//   }, []);
//   const { individualAssignmentDocument } = assignmentDocument;
//   const document = individualAssignmentDocument[0]?.document;
//   console.log("document1", document);
//   console.log("document?.link", document?.link);

//   // if (loading) return <p>Loading document...</p>;
//   // if (error) return <p>{error}</p>;
//   // if (!doc?.document?.link) return <p>No document found.</p>;

//   return (
//     <>
//       {/* <h2>
//         {`Name: ${individualAssignmentDocument[0]?.userId?.firstName} ${individualAssignmentDocument[0]?.userId?.lastName}`}
//       </h2>
// <h3
//   Style={{ marginTop: "1rem" }}
// >{`Document Name: ${document?.name}`}</h3>
//       <div style={{ marginTop: "1rem" }}>
//         <FileView file={document?.link} />
//       </div> */}

//       <div className="document-viewer" style={{ padding: "1rem" }}>
//         <h2>{document?.name}</h2>

//         <div style={{ marginBottom: "1rem" }}>
//           <a
//             href={document?.link}
//             download={document?.name}
//             target="_blank"
//             rel="noopener noreferrer"
//             style={{
//               padding: "8px 16px",
//               backgroundColor: "#007bff",
//               color: "#fff",
//               borderRadius: "4px",
//               textDecoration: "none",
//             }}
//           >
//             Download PDF
//           </a>
//         </div>

//         <iframe
//           src={document?.link}
//           title={document?.name}
//           width="100%"
//           height="600px"
//           style={{ border: "1px solid #ccc", borderRadius: "4px" }}
//         />
//       </div>
//     </>
//   );
// };

// export default DocumentViewer;

import ReactFileViewer from "react-file-viewer";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIndividualAssignmentDocument } from "../../../redux/actions/assignmentDocumentActions";

const DocumentViewer = ({ match }) => {
  const { assignmentDocumentId } = match.params;
  const dispatch = useDispatch();
  const { assignmentDocument } = useSelector((state) => state);
  const { individualAssignmentDocument } = assignmentDocument;

  useEffect(() => {
    dispatch(getIndividualAssignmentDocument(assignmentDocumentId));
  }, [assignmentDocumentId, dispatch]);

  const document = individualAssignmentDocument?.[0]?.document;

  if (!document) return <p>Loading...</p>;

  const fileType = document.name.split(".").pop(); // e.g., pdf, docx
  const filePath = document.link;

  return (
    <div className="document-viewer" style={{ padding: "1rem" }}>
      <h2>
        {`Name: ${individualAssignmentDocument[0]?.userId?.firstName} ${individualAssignmentDocument[0]?.userId?.lastName}`}
      </h2>
      <h3
        Style={{ marginTop: "1rem" }}
      >{`Document Name: ${document?.name}`}</h3>

      <a
        href={filePath}
        download={document.name}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-block",
          marginTop: "1rem",
          padding: "8px 16px",
          backgroundColor: "#007bff",
          color: "#fff",
          borderRadius: "4px",
          textDecoration: "none",
        }}
      >
        Download
      </a>
      <div
        style={{ height: "80vh", border: "1px solid #ccc", marginTop: "1rem" }}
      >
        <ReactFileViewer
          fileType={fileType}
          filePath={filePath}
          onError={(e) => console.error("File Viewer Error:", e)}
        />
      </div>
    </div>
  );
};

export default DocumentViewer;
